module.exports = __webpack_public_path__ + "static/assets/c91ad2d54c26e228177a8b958c98cd8e.svg";